import { InjectionToken } from '@angular/core';
import { devServer, environment } from '../globals';
import { Capacitor } from '@capacitor/core';

const local = 'http://localhost:4200';
const demo = 'https://abc-dot-vbc-demo.appspot.com';
const prod = 'https://login.custom-abc.com';
const host = devServer && !Capacitor.isNativePlatform() ? local : environment == 'prod' ? prod : demo;

const baseConfig = {
  server_host: `https://iam-${environment}.apigateway.co`,
  redirect_url: `${host}/oauth/redirect`,
  end_session_redirect_url: `${host}/logout/`,
  scopes: 'openid profile offline_access business admin business-app crm user:read user user.password', // TODO (WARP-687): Need to remove admin as it is for partner users
  pkce: true,
};

function prodConfig() {
  return {
    client_id: 'ccb3ae08-fab1-4897-af06-9be02d4c8e17',
    ...baseConfig,
  };
}

function demoConfig() {
  return {
    client_id: '767f7561-5497-41ea-b87b-f3b8d7fe18b1',
    ...baseConfig,
  };
}

const config = environment == 'prod' ? prodConfig() : demoConfig();

export default new InjectionToken('auth.config', {
  providedIn: 'root',
  factory: () => config,
});
